import { getConfigData } from '../middleware';

export const isFeatureEnabled = (key) => {
  const override = process.env['REACT_APP_FEATURE_' + key.toUpperCase()];
  if (override !== undefined && override !== '') {
    return override === 'true' || override === '1';
  }

  const config = getConfigData();
  const envFeatures = config[config.env] && config[config.env].features;
  if (envFeatures && envFeatures[key] !== undefined) {
    return envFeatures[key] === true;
  }

  const globalFeatures = config.features;
  if (globalFeatures && globalFeatures[key] !== undefined) {
    return globalFeatures[key] === true;
  }

  return false;
};
